import 'es6-promise/auto'
import fetch from 'isomorphic-fetch'

const HEADER = new Headers({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  Accept: 'application/json'
})
const DEFAULT_OPTIONS = {
  HEADER,
  method: 'GET',
  credentials: 'include'
}

export default (endpoint, options = {}) => {
  options = Object.assign({}, DEFAULT_OPTIONS, options)

  return fetch(endpoint, options)
}
